"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = void 0;
const throttle = (fn, delay) => {
    let lastCallTime = 0;
    const throttledFn = (...args) => {
        // Using Date.now() allows the throttle function to be more precise and
        // reliable in managing the rate at which the original function is called.
        const now = Date.now();
        const timeSinceLastCall = now - lastCallTime;
        if (timeSinceLastCall >= delay) {
            lastCallTime = now;
            fn(...args);
            return;
        }
    };
    return throttledFn;
};
exports.throttle = throttle;
